// Path: ./src/utils/commonStyledComponents/commonStyled.ts
import styled, { createGlobalStyle } from "styled-components";
import { InputField } from "../../app/components/TextField";

export const SetupPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-top: 65px;
`;

export const SetupPageTopAppBar = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;

  flex-wrap: wrap;

  @media (max-width: 599px) {
    padding-left: 12px;
    padding-right: 12px;
  }
`;

export const TextInputField = styled(InputField)`
  margin-bottom: 10px;
`;

export const DateFormat = styled.div`
  color: gray;
  font-weight: 500;
  font-size: 12px;
  text-align: start;
  padding-left: 4px;
  background-color: white;
  border-radius: 8px;
  padding: 2px 5px;
  position: absolute;
  z-index: 99;
  bottom: 0;
  left: 0;
`;

export const S3Size = styled.div`
  color: gray;
  font-weight: 500;
  font-size: 11px;
  text-align: start;
  padding-left: 4px;
  background-color: white;
  border-radius: 8px;
  padding: 2px;
  position: absolute;
  z-index: 99;
  bottom: 16px;
  left: 3px;
`;

export const UsageCountBadge = styled.div<{ count: number }>`
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: ${(props) =>
    props.count > 0
      ? "linear-gradient(135deg, #ff813a, #e8722e)"
      : "linear-gradient(135deg, #9e9e9e, #757575)"};
  color: white;
  font-size: 10px;
  font-weight: 700;
  font-family: system-ui;
  padding: 2px 6px;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.9);
  min-width: 16px;
  text-align: center;
  z-index: 3;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 1px;

  &:before {
    content: "${(props) => (props.count > 0 ? "★" : "○")}";
    font-size: 8px;
    margin-right: 1px;
  }

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25);
  }
`;

export const UsageIndicator = styled.div`
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border: 3px solid #ff813a;
  border-radius: 10px;
  opacity: 0.6;
  pointer-events: none;
  z-index: 1;
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      opacity: 0.6;
      transform: scale(1);
    }
    50% {
      opacity: 0.8;
      transform: scale(1.02);
    }
    100% {
      opacity: 0.6;
      transform: scale(1);
    }
  }
`;
export const GlobalModalStyle = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;
